import moment from 'moment-timezone'

const makeGetAllTimezones = () => {
  const getAllTimezones = () => moment.tz.names()

  return getAllTimezones
}

export default makeGetAllTimezones
